import React from 'react';
import '../styles/TrainingVideoEditor.css';
export default function TrainingVideoEditor({ videoContent, onChange }) {
  const vc = videoContent || {};
  return (
    <>
      <div className="form-group mb-3">
        <label className="form-label">YouTube ID</label>
        <input
          type="text"
          className="form-control"
          placeholder="dQw4w9WgXcQ"
          value={vc.youtubeId || ''}
          onChange={(e) => onChange({ ...vc, youtubeId: e.target.value })}
        />
      </div>
      {vc.youtubeId && (
        <div className="mb-3" style={{ position: 'relative', width: '100%', aspectRatio: '16/9' }}>
          <iframe
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
            src={`https://www.youtube.com/embed/${vc.youtubeId}`}
            title="Preview"
            frameBorder="0"
            allowFullScreen
          />
        </div>
      )}
      <div className="form-group">
        <label className="form-label">% mínimo visto: {vc.requiredPercent ?? 85}%</label>
        <input
          type="range"
          className="form-range"
          min="0"
          max="100"
          value={vc.requiredPercent ?? 85}
          onChange={(e) => onChange({ ...vc, requiredPercent: Number(e.target.value) })}
        />
      </div>
    </>
  );
}
